import { Tag } from 'element-ui'

const YTag = Tag
YTag.$depends = [Tag]
YTag.$name = 'y-tag'
YTag._name = 'Tag 标签'

export default YTag
